export const colors = [
    '#12AEA5',
    '#f2ad70',
    '#7c86d7',
    '#f6cc96',
    '#83c682',
    '#455ccc',
    '#EE6666',
    '#1CA550',

    // '#1D4CD2',
    // '#1CA550',

    // '#ff9a3e',
    // '#EE6666',
    // '#63b2d6'
]